import { render, staticRenderFns } from "./essential.vue?vue&type=template&id=5cafbf5b&scoped=true"
import script from "./essential.vue?vue&type=script&lang=js"
export * from "./essential.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=5cafbf5b&prod&lang=scss&scoped=true&external"
import style1 from "./essential.vue?vue&type=style&index=1&id=5cafbf5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cafbf5b",
  null
  
)

export default component.exports